import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import brandLogo from '../images/WhatsApp Image 2026-05-17 at 11.51.42 AM.jpeg';
import dynastyLogo from '../images/dynasty-logo.png';


const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="spq-footer">
      <div className="spq-footer__inner">
        <div className="spq-footer__brand">
          <div className="spq-footer__logo">
            <div className="spq-footer__logo-card">
              <img src={brandLogo} alt="Dynasty Agri Seeds" className="spq-footer__logo-image" />
              <img src={dynastyLogo} alt="Dynasty logo" className="spq-footer__logo-image-secondary" />
            </div>
          </div>

          <p className="spq-footer__desc">
            Dynasty Agri Seeds is one of the leading vegetable seeds companies located at Bangalore, India.
          </p>

          {/* <div className="spq-footer__socials" aria-label="Social links">
            {['f', 't', 'in', 'w', 'yt'].map((s) => (
              <button key={s} type="button" className="spq-social-btn" aria-label={s}>
                {s}
              </button>
            ))}
          </div> */}

          {/* <button type="button" className="spq-mgt-btn">
            DYNASTY AGRI SEEDS MGT 7A FORM
          </button> */}
        </div>

        <div className="spq-footer__links">
          <h4>Quick Links</h4>
          <Link to="/">
            <span className="spq-arrow">&raquo;</span> Home
          </Link>
          <Link to="/about">
            <span className="spq-arrow">&raquo;</span> About Us
          </Link>
          <Link to="/products">
            <span className="spq-arrow">&raquo;</span> Products
          </Link>
          <Link to="/contact">
            <span className="spq-arrow">&raquo;</span> Contact
          </Link>
        </div>

        <div className="spq-footer__contact">
          <div className="spq-contact-item">
            <span className="spq-contact-icon">✉</span>
            <span>dynastyagriseeds2024@gmail.com</span>
          </div>
          <div className="spq-contact-item">
            <span className="spq-contact-icon">📞</span>
            <span>+91 90590 57001</span>
          </div>
          <div className="spq-contact-item spq-contact-item--addr">
            <span className="spq-contact-icon">📍</span>
            <span>
              M/s DYNASTY AGRI SEEDS PVT. LTD.,Shop No. 1& 2, 154/265B, Palanagogahalli,
Kodigehalli Post, Kasaba Hobli, Doddaballapur Taluk,
Bengaluru Rural Dist - 561203, Cell: 90590 57001 <strong>Email:</strong> dynastyagriseeds2024@gmail.com <strong>Website:</strong> www. dynastyagriseeds.com
            </span>
          </div>
        </div>
      </div>

      <div className="spq-footer__bar">
        <p>
          Copyright {currentYear} <strong>DYNASTY AGRI SEEDS</strong>. All Right Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
